export enum UserSettingType {
  IntroRewardSelectionCompletion = 1,
  WelcomeModalAcknowledgement = 2,
  SurveyIntroCompletion = 3,
  PostRegistrationFormCompletion = 4,
  FirstDynamicProfilerCompletion = 5,
  ProfileSurveyCompletion = 6,
  LatestUserToProjectMatch = 7,
  LastSpectrumFusionCall = 8,
  TrustpilotInviteEligible = 9,

  // [DELETE IN PROD-790]
  NotifyAboutNewLevelingUpSystem = 10,
  NewLevelingUpPointsRewarded = 11,
  // [END OF DELETION]

  // [DELETE IN PROD-792]
  NotifyAboutNewStreakSystem = 12,
  // [END OF DELETION]
  // RB keeps ID 13 reserved for the legacy StreakFreezesIntro database row.
  LatestUserToGameMatch = 951,
  ShowGamesOnboarding = 17,
  ShowLevelUpModalFromGames = 18,
  GamesPlatformOsType = 20,
  PayPalEmail = 97,
  WeeklySummarySent = 98,
  StreakReminderSent = 99,
  LastTapResearchCall = 100,
  HapticsEnabled = 950,
  LastAyetOfferwallCall = 952,
  BrowserNotificationsEnabled = 953,
  BrowserNotificationsPromptDismissed = 954,
  UnreadGameInviteCount = 956,
  UnreadProjectInviteCount = 957,
  LastGameInviteSeenAt = 958,
  LastProjectInviteSeenAt = 959,
  ShowPointsToCashConversionNotice = 960,
}
